import { ACTIVITIES } from "constants/routes";
import { serviceRoles } from "config/access";
import { checkAccess } from "helpers/auth";
import ActivitiePage from "./container/ActivitiePage";

export default function getSettingsRoute(userAuth) {
  const { account } = serviceRoles;
  const requireAuth = {
    [account.name]: [account.roles.superadmin],
  };
  return {
    requireAuth,
    onEnter: () => checkAccess(requireAuth, userAuth),
    path: ACTIVITIES,
    withSidebar: true,
    withAppBar: true,
    component: ActivitiePage,
  };
}
